import { CountryDropdownButton } from "@similarweb/ui-components";

import * as SC from "./styles";

type CountryDisplaySchema = { id: number; name: string };

export const CountryDisplay = ({ id, name }: CountryDisplaySchema) => (
    <SC.SingleCountry>
        <CountryDropdownButton countryId={id}>{name}</CountryDropdownButton>
    </SC.SingleCountry>
);
